export { default, TabsProps } from '@material-ui/core/Tabs';
